import { Dictionary } from '../../base/dictionary';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { TextPosition } from '../selection/selection-helper';
import { TextElementBox, FieldElementBox } from '../viewer/page';
import { TextSearch } from '../search/text-search';
import { TextSearchResults } from '../search/text-search-results';
/**
 * Search module
 */
var Search = /** @class */ (function () {
    /**
     * @private
     */
    function Search(owner) {
        this.owner = owner;
        this.textSearch = new TextSearch(this.owner);
        this.textSearchResults = new TextSearchResults(this.owner);
    }
    Object.defineProperty(Search.prototype, "viewer", {
        /**
         * @private
         */
        get: function () {
            return this.owner.viewer;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Get the module name.
     */
    Search.prototype.getModuleName = function () {
        return 'Search';
    };
    /**
     * Finds the immediate occurrence of specified text from cursor position in the document.
     * @param  {string} text
     * @param  {FindOption} findOption? - Default value of ‘findOptions’ parameter is 'None'.
     * @private
     */
    Search.prototype.find = function (text, findOptions) {
        if (isNullOrUndefined(findOptions)) {
            findOptions = 'None';
        }
        var textSearch = new TextSearch(this.owner);
        var result = textSearch.find(text, findOptions);
        if (!isNullOrUndefined(result)) {
            this.navigate(result);
        }
    };
    /**
     * Finds all occurrence of specified text in the document.
     * @param  {string} text
     * @param  {FindOption} findOption? - Default value of ‘findOptions’ parameter is 'None'.
     * @private
     */
    Search.prototype.findAll = function (text, findOptions) {
        if (isNullOrUndefined(findOptions)) {
            findOptions = 'None';
        }
        var textSearch = new TextSearch(this.owner);
        var results = textSearch.findAll(text, findOptions);
        if (!isNullOrUndefined(results) && results.length > 0) {
            this.navigate(results.innerList[results.currentIndex]);
            this.highlight(results);
        }
    };
    /**
     * Find the textToFind string in current document and replace the specified string.
     * @param  {string} textToFind
     * @param  {string} textToReplace
     * @param  {FindOption} findOptions? - Default value of ‘findOptions’ parameter is FindOption.None.
     * @private
     */
    Search.prototype.replaceAllInternal = function (textToFind, textToReplace, findOptions) {
        if ((textToFind === '' || isNullOrUndefined(textToFind)) || (textToReplace === '' || isNullOrUndefined(textToReplace))) {
            return;
        }
        if (isNullOrUndefined(findOptions)) {
            findOptions = 'None';
        }
        var textSearch = new TextSearch(this.owner);
        var textSearchResults = new TextSearchResults(this.owner);
        var results = textSearch.findAll(textToFind, findOptions);
        if (!isNullOrUndefined(results) && results.length > 0) {
            this.owner.searchModule.navigate(results.innerList[results.currentIndex]);
            this.owner.searchModule.highlight(results);
            this.replaceAll(textToReplace, textSearchResults);
        }
    };
    /**
     * Find the textToFind string in current document and replace the specified string.
     * @param  {string} textToFind
     * @param  {string} textToReplace
     * @param  {FindOption} findOptions? - Default value of ‘findOptions’ parameter is FindOption.None.
     * @private
     */
    Search.prototype.replaceInternal = function (textToFind, textToReplace, findOptions) {
        if ((isNullOrUndefined(textToFind) || textToFind === '') || (textToReplace === '' || isNullOrUndefined(textToReplace))) {
            return;
        }
        if (isNullOrUndefined(findOptions)) {
            findOptions = 'None';
        }
        var textSearch = new TextSearch(this.owner);
        var textSearchResults = new TextSearchResults(this.owner);
        var result = textSearch.find(textToFind, findOptions);
        if (!isNullOrUndefined(result)) {
            this.navigate(result);
            textSearchResults.addResult();
            textSearchResults.innerList[0] = result;
            this.replace(textToReplace, result, textSearchResults);
            var index = this.owner.selection.end.getHierarchicalIndexInternal();
            result = textSearch.findNext(textToFind, findOptions, index);
            textSearchResults.addResult();
            textSearchResults.innerList[0] = result;
            this.owner.searchModule.navigate(result);
        }
    };
    /**
     * @private
     */
    Search.prototype.navigate = function (textSearchResult) {
        var start = textSearchResult.start;
        var end = textSearchResult.end;
        // tslint:disable-next-line:max-line-length
        if (!isNullOrUndefined(this.owner) && !isNullOrUndefined(this.owner.selection) && !isNullOrUndefined(start) && !isNullOrUndefined(end) && !isNullOrUndefined(start.paragraph) && !isNullOrUndefined(end.paragraph)) {
            this.owner.selection.selectRange(start, end);
        }
    };
    /**
     * @private
     */
    Search.prototype.highlight = function (textSearchResults) {
        if (this.owner.optionsPaneModule) {
            this.owner.optionsPaneModule.searchHighlighters = new Dictionary();
            for (var i = 0; i < textSearchResults.innerList.length; i++) {
                var result = textSearchResults.innerList[i];
                this.highlightResult(result);
            }
            this.viewer.renderVisiblePages();
        }
    };
    /**
     * @private
     */
    Search.prototype.highlightResult = function (result) {
        this.owner.optionsPaneModule.highlightSearchResult(result.start.paragraph, result.start, result.end);
    };
    /**
     * @private
     */
    Search.prototype.addSearchResultItems = function (result) {
        if (isNullOrUndefined(result) || result === '') {
            return;
        }
        if (isNullOrUndefined(this.owner.findResultsList)) {
            this.owner.findResultsList = [];
        }
        this.owner.findResultsList.push(result);
    };
    /**
     * @private
     */
    Search.prototype.addFindResultView = function (textSearchResults) {
        for (var i = 0; i < textSearchResults.innerList.length; i++) {
            var result = textSearchResults.innerList[i];
            this.addFindResultViewForSearch(result);
        }
    };
    /**
     * @private
     */
    Search.prototype.addFindResultViewForSearch = function (result) {
        if (result.start != null && result.end != null && result.start.paragraph != null && result.end.paragraph != null) {
            var prefixText = void 0;
            var suffixtext = void 0;
            var currentText = void 0;
            var startIndex = 0;
            var inlineObj = result.start.currentWidget.getInline(result.start.offset, startIndex);
            var inline = inlineObj.element;
            startIndex = inlineObj.index;
            var prefix = '';
            var lastIndex = 0;
            if (inline instanceof FieldElementBox) {
                var elementInfo = this.owner.selection.getRenderedInline(inline, startIndex);
                if (elementInfo.element.nextNode instanceof TextElementBox) {
                    inline = elementInfo.element.nextNode;
                    startIndex = elementInfo.index;
                }
                else {
                    inline = elementInfo.element;
                    startIndex = elementInfo.index;
                }
            }
            var boxObj = this.owner.selection.getElementBoxInternal(inline, startIndex);
            var box = boxObj.element;
            startIndex = boxObj.index;
            if (box != null) {
                if (box instanceof TextElementBox && startIndex > 0) {
                    prefix = box.text.substring(0, startIndex);
                }
                var boxIndex = box.line.children.indexOf(box);
                // tslint:disable-next-line:max-line-length
                lastIndex = prefix.lastIndexOf(' ');
                while (lastIndex < 0 && boxIndex > 0 && box.line.children[boxIndex - 1] instanceof TextElementBox) {
                    prefix = box.line.children[boxIndex - 1].text + prefix;
                    boxIndex--;
                    lastIndex = prefix.lastIndexOf(' ');
                }
            }
            var shiftIndex = prefix.lastIndexOf('\v');
            if (shiftIndex > 0) {
                prefix = prefix.substring(0, shiftIndex);
            }
            else {
                lastIndex = prefix.lastIndexOf(' ');
                prefixText = lastIndex < 0 ? prefix : prefix.substring(lastIndex + 1);
            }
            currentText = result.text;
            var endIndex = 0;
            var endInlineObj = result.end.currentWidget.getInline(result.end.offset, endIndex);
            var endInline = endInlineObj.element;
            endIndex = endInlineObj.index;
            suffixtext = '';
            //Checks prefix element box is empty
            if (boxObj != null) {
                // Gets the element box using endIndex of the text and set as suffix
                boxObj = this.owner.selection.getElementBoxInternal(endInline, endIndex);
                box = boxObj.element;
                endIndex = boxObj.index;
            }
            //Checks suffix element box is empty.
            if (box != null) {
                if (box instanceof TextElementBox && endIndex < box.length) {
                    suffixtext = box.text.substring(endIndex);
                }
                var boxIndex = box.line.children.indexOf(box);
                // tslint:disable-next-line:max-line-length
                while (boxIndex + 1 < box.line.children.length && (box.line.children[boxIndex + 1] instanceof TextElementBox) || (box.line.children[boxIndex + 1] instanceof FieldElementBox)) {
                    if (box.line.children[boxIndex + 1] instanceof FieldElementBox) {
                        boxIndex = boxIndex + 2;
                    }
                    else {
                        suffixtext = suffixtext + box.line.children[boxIndex + 1].text;
                        boxIndex = boxIndex + 1;
                    }
                }
            }
            lastIndex = suffixtext.lastIndexOf(' ');
            suffixtext = suffixtext === '\v' ? suffixtext = '' : suffixtext;
            // tslint:disable-next-line:max-line-length
            var listElement = '<li tabindex=0 class="e-de-search-result-item e-de-op-search-txt">' + prefix + '<span class="e-de-op-search-word" style="pointer-events:none">' + result.text + '</span>' + suffixtext + '</li>';
            this.addSearchResultItems(listElement);
        }
    };
    //Replace and Replace All API    
    /**
     * Replace the searched string with specified string
     * @param  {string} replaceText
     * @param  {TextSearchResult} result
     * @param  {TextSearchResults} results
     * @private
     */
    Search.prototype.replace = function (replaceText, result, results) {
        if (isNullOrUndefined(this.viewer.owner.optionsPaneModule)) {
            return 0;
        }
        if (!isNullOrUndefined(this.viewer)) {
            this.viewer.owner.optionsPaneModule.clearSearchHighlight();
        }
        this.viewer.owner.searchModule.navigate(results.innerList[0]);
        var endPosition = this.viewer.selection.start;
        var index = results.indexOf(result);
        if (index < 0) {
            return 0;
        }
        this.owner.editorModule.insertText(replaceText, true);
        var startTextPosition = result.start;
        var endTextPosition = result.end;
        var difference = endTextPosition.offset - (startTextPosition.offset + replaceText.length);
        var startPosition = new TextPosition(this.viewer.owner);
        startPosition.setPositionParagraph(endTextPosition.currentWidget, endPosition.offset - replaceText.length);
        this.viewer.selection.selectRange(endPosition, startPosition);
        return 1;
    };
    /**
     * Replace all the searched string with specified string
     * @param  {string} replaceText
     * @param  {TextSearchResults} results
     * @private
     */
    Search.prototype.replaceAll = function (replaceText, results) {
        // tslint:disable-next-line:max-line-length
        if (isNullOrUndefined(this.viewer.owner) || this.viewer.owner.isReadOnlyMode || isNullOrUndefined(results) || isNullOrUndefined(this.viewer.owner.optionsPaneModule)) {
            return 0;
        }
        this.viewer.owner.optionsPaneModule.clearSearchHighlight();
        if (this.owner.editorHistory) {
            this.owner.editorHistory.initComplexHistory(this.owner.selection, 'ReplaceAll');
        }
        var count = results.length;
        this.viewer.owner.isLayoutEnabled = false;
        for (var i = count - 1; i >= 0; i--) {
            this.viewer.owner.searchModule.navigate(results.innerList[i]);
            this.owner.editorModule.insertText(replaceText, true);
            results.innerList[i].destroy();
        }
        if (this.owner.editorHistory && !isNullOrUndefined(this.owner.editorHistory.currentHistoryInfo)) {
            this.owner.editorHistory.updateComplexHistory();
        }
        else {
            this.owner.editorModule.updateComplexWithoutHistory(2);
        }
        return count;
    };
    /**
     * @private
     */
    Search.prototype.destroy = function () {
        if (this.textSearchResults) {
            this.textSearchResults.destroy();
        }
    };
    return Search;
}());
export { Search };
